class ServicoController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'servicoService', 'faturaServicoService' ]

  Alert = null
  constructor: ($injector, @pathService, @servicoService, @faturaServicoService)->
    super($injector)

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()

    @loadingTracker.addPromise @servicoService.getList((data) => @listOfServico = data)

    @loadingTracker.addPromise @faturaServicoService.search({select_type: 'simple'}, (data)=>
      @listOfFaturaServico = data
    )

  salvar: ->
    @submitTracker.addPromise @servicoService.setConfig @listOfServico, ((data) =>
      if data.success
        @Alert.success("Serviços salvos com sucesso.", "Sucesso")
      else
        @Alert.error("Ocorreu um erro ao tentar salvar os serviços.", "Erro")
    )

angular.module("eficienciaFiscalModule").controller('servicoController', ServicoController)
